import React from 'react';
import {TestimonialsSlider} from '~/components/elements/TestimonialSlider';


export const Reviews = (props) => {
  const { heading, reviews} = props;
  return (
    <div className="container">
      <div className="max-w-[1200px] mx-auto">
        <div className="space-y-7 flex flex-col items-center text-center">
          <TestimonialsSlider heading={heading} reviews={reviews}/>
        </div>
      </div>
    </div>
  );
};
